import React, { Fragment } from 'react';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { Check, Close } from '../../common/icons';
export function Slot(props) {
  var status = props.status,
      percent = props.percent,
      format = props.format;
  var iconCheck = usePrefixCls('progress-icon-check');
  var iconClose = usePrefixCls('progress-icon-close');
  var circleIconCheck = classnames(iconCheck, usePrefixCls('progress-icon-circle'));
  var circleIconClose = classnames(iconClose, usePrefixCls('progress-icon-circle'));
  var slotCls = usePrefixCls('progress-slot');
  return React.createElement(Fragment, null, [status === 'exception' && typeof format !== 'function' && React.createElement(Close, {
    key: 0,
    className: circleIconClose
  }), status === 'success' && typeof format !== 'function' && React.createElement(Check, {
    key: 1,
    className: circleIconCheck
  }), typeof format === 'function' && React.createElement("span", {
    key: 2,
    className: slotCls
  }, format(percent))]);
}